export type TUpgradeState = {
    isShowingUpgradeModal: boolean
    upgradeContext: {
        quizMode?: 'weakest' | 'missed'
        upgradePurchasePressed?: boolean
    } | null
}

export const getInitialUpgradeState = (): TUpgradeState => {
    return {
        upgradeContext: null,
        isShowingUpgradeModal: false,
    }
}

const moduleState = getInitialUpgradeState()

export default moduleState
